import Modalform from './Modalform.vue';
export default Modalform;



// WEBPACK FOOTER //
// ./src/components/modalform/index.js